/* Babygami fold demo: real photos of the bottle folding, driven by a slider.
   Auto-plays left to right (open, half, folded, then restarts from open), never in reverse.
   Pause/Play button; touching the slider pauses it and it resumes 3.5 s after release.
   Shows a height bracket for the bottle at each stage, and an optional real avocado photo at true scale. */
(function () {
  if (window.__bgFoldLoaded) return;
  window.__bgFoldLoaded = true;

  // Photo geometry (716 px square frames shot from the same spot): rock line, and top of the nipple per stage.
  var BASE_Y = 688;
  var BOTTLE_TOP = [225, 318, 410];
  var LABELS = ['Open, 8 oz', 'Half folded', 'Folded'];
  var NS = 'http://www.w3.org/2000/svg';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function inch(v) { return (Math.round(v * 10) / 10).toFixed(1) + ' in'; }
  function cm(v) { var c = Math.round(v * 2.54 * 2) / 2; return (c % 1 ? c.toFixed(1) : c.toFixed(0)) + ' cm'; }

  function el(tag, attrs) { var n = document.createElementNS(NS, tag); for (var k in attrs) n.setAttribute(k, attrs[k]); return n; }

  var avoCount = 0;
  // Soft, friendly avocado (a medium Hass is about 65 x 105 mm) standing on the rock to the right of the bottle.
  function avocadoArt(avoIn, pxPerIn) {
    var uid = 'bgavo' + (avoCount++);
    var ah = avoIn * pxPerIn, aw = ah * 65 / 105;
    var cx = 608, top = BASE_Y - ah, L = cx - aw / 2, R = cx + aw / 2;
    var k = function (f) { return (top + ah * f).toFixed(1); };
    var d = 'M' + cx + ',' + top.toFixed(1) +
      ' C' + (cx + aw * 0.27) + ',' + top.toFixed(1) + ' ' + (cx + aw * 0.38) + ',' + k(0.13) + ' ' + (cx + aw * 0.4) + ',' + k(0.3) +
      ' C' + (cx + aw * 0.42) + ',' + k(0.44) + ' ' + R + ',' + k(0.54) + ' ' + R + ',' + k(0.71) +
      ' C' + R + ',' + k(0.9) + ' ' + (cx + aw * 0.27) + ',' + BASE_Y + ' ' + cx + ',' + BASE_Y +
      ' C' + (cx - aw * 0.27) + ',' + BASE_Y + ' ' + L + ',' + k(0.9) + ' ' + L + ',' + k(0.71) +
      ' C' + L + ',' + k(0.54) + ' ' + (cx - aw * 0.42) + ',' + k(0.44) + ' ' + (cx - aw * 0.4) + ',' + k(0.3) +
      ' C' + (cx - aw * 0.38) + ',' + k(0.13) + ' ' + (cx - aw * 0.27) + ',' + top.toFixed(1) + ' ' + cx + ',' + top.toFixed(1) + ' Z';
    var dots = '';
    for (var i = 0; i < 22; i++) {
      var fx = ((i * 37) % 100) / 100, fy = ((i * 61) % 100) / 100;
      var y = top + ah * (0.1 + fy * 0.82), half = aw / 2 * (y > top + ah * 0.5 ? 0.9 : 0.7 + (y - top) / ah * 0.5);
      dots += '<circle cx="' + (cx + (fx * 2 - 1) * half * 0.82).toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + (1.4 + (i % 2)).toFixed(1) + '"/>';
    }
    var eyeY = +k(0.6), eyeDX = aw * 0.15, er = aw * 0.042;
    var face =
      '<ellipse cx="' + (cx - eyeDX).toFixed(1) + '" cy="' + eyeY.toFixed(1) + '" rx="' + er.toFixed(1) + '" ry="' + (er * 1.15).toFixed(1) + '" fill="#2f3a1f"/>' +
      '<ellipse cx="' + (cx + eyeDX).toFixed(1) + '" cy="' + eyeY.toFixed(1) + '" rx="' + er.toFixed(1) + '" ry="' + (er * 1.15).toFixed(1) + '" fill="#2f3a1f"/>' +
      '<circle cx="' + (cx - eyeDX + er * 0.35).toFixed(1) + '" cy="' + (eyeY - er * 0.45).toFixed(1) + '" r="' + (er * 0.38).toFixed(1) + '" fill="#fff"/>' +
      '<circle cx="' + (cx + eyeDX + er * 0.35).toFixed(1) + '" cy="' + (eyeY - er * 0.45).toFixed(1) + '" r="' + (er * 0.38).toFixed(1) + '" fill="#fff"/>' +
      '<path d="M' + (cx - aw * 0.075).toFixed(1) + ',' + (eyeY + ah * 0.065).toFixed(1) + ' q' + (aw * 0.075).toFixed(1) + ',' + (ah * 0.05).toFixed(1) + ' ' + (aw * 0.15).toFixed(1) + ',0" stroke="#2f3a1f" stroke-width="4" stroke-linecap="round" fill="none"/>' +
      '<ellipse cx="' + (cx - aw * 0.27).toFixed(1) + '" cy="' + (eyeY + ah * 0.055).toFixed(1) + '" rx="' + (aw * 0.065).toFixed(1) + '" ry="' + (aw * 0.038).toFixed(1) + '" fill="#f59d9d" opacity=".75"/>' +
      '<ellipse cx="' + (cx + aw * 0.27).toFixed(1) + '" cy="' + (eyeY + ah * 0.055).toFixed(1) + '" rx="' + (aw * 0.065).toFixed(1) + '" ry="' + (aw * 0.038).toFixed(1) + '" fill="#f59d9d" opacity=".75"/>';
    var labelY = top - 26;
    var g = el('g', {});
    g.innerHTML =
      '<defs><radialGradient id="' + uid + 'g" cx="36%" cy="30%" r="82%"><stop offset="0" stop-color="#d4ec9a"/><stop offset=".5" stop-color="#a9d067"/><stop offset="1" stop-color="#7fae45"/></radialGradient>' +
      '<clipPath id="' + uid + 'c"><path d="' + d + '"/></clipPath></defs>' +
      '<ellipse cx="' + cx + '" cy="' + (BASE_Y + 2) + '" rx="' + (aw * 0.55).toFixed(1) + '" ry="10" fill="rgba(20,25,15,.3)"/>' +
      '<path d="' + d + '" fill="url(#' + uid + 'g)" stroke="#6f9a3c" stroke-width="3"/>' +
      '<g clip-path="url(#' + uid + 'c)" fill="rgba(80,120,35,.28)">' + dots + '</g>' +
      '<ellipse cx="' + (cx - aw * 0.2).toFixed(1) + '" cy="' + k(0.4) + '" rx="' + (aw * 0.09).toFixed(1) + '" ry="' + (ah * 0.13).toFixed(1) + '" fill="rgba(255,255,255,.35)" transform="rotate(-12 ' + (cx - aw * 0.2).toFixed(1) + ' ' + k(0.4) + ')"/>' +
      face +
      '<path d="M' + cx + ',' + (top + 3) + ' q1,-10 6,-15" stroke="#7a5a35" stroke-width="5" stroke-linecap="round" fill="none"/>' +
      '<path d="M' + (cx + 5) + ',' + (top - 11) + ' c10,-14 30,-14 38,-6 c-10,12 -28,14 -38,6 z" fill="#8cc152" stroke="#6f9a3c" stroke-width="2"/>' +
      '<line class="guide" x1="250" x2="' + (L - 6).toFixed(1) + '" y1="' + top.toFixed(1) + '" y2="' + top.toFixed(1) + '"/>' +
      '<rect class="pill" x="' + (cx - 86) + '" y="' + (labelY - 52).toFixed(1) + '" width="172" height="58" rx="14"/>' +
      '<text x="' + cx + '" y="' + (labelY - 26).toFixed(1) + '" text-anchor="middle" font-size="22">Avocado ' + inch(avoIn) + '</text>' +
      '<text class="sub" x="' + cx + '" y="' + (labelY - 3).toFixed(1) + '" text-anchor="middle" font-size="17">' + cm(avoIn) + ' tall</text>';
    return g;
  }

  function init(root) {
    if (root.__bgFold) return;
    root.__bgFold = true;
    var photo = root.querySelector('.bg-fold-photo');
    var imgs = Array.prototype.slice.call(photo.querySelectorAll('img'));
    var input = root.querySelector('input[type="range"]');
    var out = root.querySelector('output');
    var btn = root.querySelector('.bg-fold-play');
    var heights = (root.dataset.heights || '5.6,4.6,3.5').split(',').map(Number);
    var pxPerIn = (BASE_Y - BOTTLE_TOP[2]) / heights[2];

    // Height bracket on the left of the bottle
    var svg = el('svg', { class: 'bg-fold-scale', viewBox: '0 0 716 716', 'aria-hidden': 'true', focusable: 'false' });
    var g = el('g', {});
    var line = el('line', { class: 'dim', x1: 232, x2: 232 }), lineInk = el('line', { class: 'dim-ink', x1: 232, x2: 232 });
    var capTop = el('line', { class: 'dim', x1: 222, x2: 242 }), capBot = el('line', { class: 'dim', x1: 222, x2: 242, y1: BASE_Y, y2: BASE_Y });
    var pill = el('rect', { class: 'pill', x: 118, width: 104, height: 58, rx: 14 });
    var tIn = el('text', { x: 170, 'text-anchor': 'middle', 'font-size': 22 }), tCm = el('text', { class: 'sub', x: 170, 'text-anchor': 'middle', 'font-size': 17 });
    [line, lineInk, capTop, capBot, pill, tIn, tCm].forEach(function (n) { g.appendChild(n); });
    svg.appendChild(g);

    // Optional real avocado photo at true scale, standing on the same rock to the right of the bottle
    if (root.dataset.avocadoSrc) {
      var avoIn = Number(root.dataset.avocadoIn || 4.1);
      var avoH = avoIn * pxPerIn;
      var avo = el('image', { href: root.dataset.avocadoSrc, x: 520, y: BASE_Y - avoH, height: avoH, width: 176, preserveAspectRatio: 'xMidYMax meet' });
      svg.appendChild(avo);
      var top = BASE_Y - avoH, lx = 608;
      svg.appendChild(el('rect', { class: 'pill', x: lx - 86, y: top - 70, width: 172, height: 58, rx: 14 }));
      var a1 = el('text', { x: lx, y: top - 44, 'text-anchor': 'middle', 'font-size': 22 }); a1.textContent = 'Avocado ' + inch(avoIn);
      var a2 = el('text', { class: 'sub', x: lx, y: top - 21, 'text-anchor': 'middle', 'font-size': 17 }); a2.textContent = cm(avoIn) + ' tall';
      svg.appendChild(a1); svg.appendChild(a2);
    } else {
      // No photo yet: the illustrated avocado from the redesign, at the same true scale, with a guide line to the bottle
      svg.appendChild(avocadoArt(Number(root.dataset.avocadoIn || 4.1), pxPerIn));
    }
    photo.appendChild(svg);

    function placeDim(i) {
      var t = BOTTLE_TOP[i], mid = (t + BASE_Y) / 2;
      [line, lineInk].forEach(function (n) { n.setAttribute('y1', t); n.setAttribute('y2', BASE_Y); });
      capTop.setAttribute('y1', t); capTop.setAttribute('y2', t);
      pill.setAttribute('y', mid - 29); tIn.setAttribute('y', mid - 3); tCm.setAttribute('y', mid + 20);
      tIn.textContent = inch(heights[i]); tCm.textContent = cm(heights[i]);
    }

    var shown = -1;
    function show(v) {
      var i = Math.round(v);
      if (i === shown) return;
      shown = i;
      imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === i); });
      out.textContent = LABELS[i];
      input.setAttribute('aria-valuetext', LABELS[i] + ', about ' + inch(heights[i]) + ' tall');
      placeDim(i);
    }
    input.addEventListener('input', function () { show(input.value); });
    show(input.value);
    imgs.forEach(function (im) { im.loading = 'eager'; });

    // Autoplay keyframes [ms, value]: always open -> folded, then snaps back to open.
    var KF = [[0, 0], [1300, 0], [2000, 1], [2900, 1], [3600, 2], [5400, 2]];
    var LOOP = KF[KF.length - 1][0];
    function ease(x) { return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; }
    function valueAt(t) {
      for (var i = 1; i < KF.length; i++) if (t <= KF[i][0]) {
        var a = KF[i - 1], b = KF[i], f = (t - a[0]) / (b[0] - a[0] || 1);
        return a[1] + (b[1] - a[1]) * ease(f);
      }
      return 0;
    }
    var wantPlay = !reduceMotion, visible = false, held = false, raf = 0, t0 = 0, resumeT = 0;
    function syncBtn() {
      btn.hidden = false;
      btn.innerHTML = wantPlay
        ? '<svg viewBox="0 0 10 10" aria-hidden="true"><rect x="1" y="1" width="3" height="8"/><rect x="6" y="1" width="3" height="8"/></svg>Pause'
        : '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M2 1l7 4-7 4z"/></svg>Play';
      btn.setAttribute('aria-label', wantPlay ? 'Pause the fold animation' : 'Play the fold animation');
    }
    function tick(now) {
      var v = valueAt((now - t0) % LOOP);
      input.value = v.toFixed(2); show(v);
      raf = requestAnimationFrame(tick);
    }
    function run() {
      var go = wantPlay && visible && !held && !document.hidden;
      if (go && !raf) {
        var v = Number(input.value), start = 0;
        for (var i = 1; i < KF.length; i++) {
          if (KF[i][1] !== KF[i - 1][1] && KF[i][1] >= v - 0.001 && KF[i - 1][1] <= v + 0.001) {
            start = KF[i - 1][0] + (KF[i][0] - KF[i - 1][0]) * (v - KF[i - 1][1]) / (KF[i][1] - KF[i - 1][1]);
            break;
          }
        }
        t0 = performance.now() - start;
        raf = requestAnimationFrame(tick);
      } else if (!go && raf) { cancelAnimationFrame(raf); raf = 0; }
    }
    function hold() { held = true; clearTimeout(resumeT); run(); }
    function release() { clearTimeout(resumeT); resumeT = setTimeout(function () { held = false; run(); }, 3500); }
    ['pointerdown', 'touchstart', 'keydown', 'focus'].forEach(function (ev) { input.addEventListener(ev, hold, { passive: true }); });
    ['pointerup', 'touchend', 'change', 'blur'].forEach(function (ev) { input.addEventListener(ev, release, { passive: true }); });
    input.addEventListener('input', function (e) { if (e.isTrusted) { hold(); release(); } });
    btn.addEventListener('click', function () { wantPlay = !wantPlay; held = false; syncBtn(); run(); });
    document.addEventListener('visibilitychange', run);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; run(); }, { threshold: 0.35 }).observe(root);
    } else { visible = true; run(); }
    syncBtn();
  }

  function boot() { document.querySelectorAll('[data-bg-fold]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme editor: re-init when sections are added or re-rendered
  document.addEventListener('shopify:section:load', boot);
})();
